export type UsageColor = 'danger' | 'warning' | 'secondary';

export function usageColorFor(percent: number): UsageColor {
  if (percent >= 90) return 'danger';
  if (percent >= 70) return 'warning';
  return 'secondary';
}
